import React from "react";
import { withErrorBoundary } from "lib/hoc";
import { BulkActivity } from "app/userManagement/modules/generic";

const AdminBulkActivity = () => {
  return <BulkActivity />;
};

export default withErrorBoundary(AdminBulkActivity);
